var _circle, _circle2, _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBinoclar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.2321,
    cy: 33.2321,
    r: 32.2321,
    fill: "#B7C2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2094_53085",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 65,
    height: 65
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.2321,
    cy: 33.2321,
    r: 32.2321,
    fill: "#B7C2FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2094_53085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.83902 59.1825C0.770099 54.5687 6.64375 47.8175 14.2512 47.8175C18.568 47.8175 22.7904 47.8175 24.4652 43.0285C25.7744 39.2557 27.3313 32.9366 27.3313 24.8304C27.3313 20.275 22.8848 16 17.9901 16C11.7862 16 8.21242 19.8896 7.30425 24.3865C6.39607 28.8835 2.38594 32.3292 -0.940102 32.3292C-4.64357 32.3292 -7.43887 35.553 -7.43887 39.2207C-7.43887 42.8883 -9.17266 44.909 -12.7346 44.909C-16.2965 44.909 -20 48.6351 -20 54.6272C-20 60.6192 -16.898 65.1162 -12.2864 65.1162C-7.67476 65.1162 -5.96456 63.1655 -2.83902 59.1825Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.931 37.1154C14.931 37.1154 15.6668 41.4633 20.1251 41.4633C24.5834 41.4633 24.1234 37.27 24.4065 34.3266C24.6896 31.3831 25.6567 22.7324 25.6567 22.7324C25.6567 22.7324 25.2439 23.6085 24.8193 23.6085C24.4065 23.6085 23.9819 22.7324 23.9819 22.7324C23.9819 22.7324 23.9229 23.9238 23.4158 23.9238C22.9086 23.9238 22.4132 23.1062 22.4132 23.1062C22.4132 23.1062 22.024 24.3093 21.3281 24.3093C20.6323 24.3093 20.3964 22.7441 20.3964 22.7441C20.3964 22.7441 20.2548 24.7298 19.1462 24.7298C18.0257 24.7298 17.9313 23.0712 17.9313 23.0712C17.9313 23.0712 17.9785 24.7765 16.9996 24.7765C16.0206 24.7765 15.655 23.0244 15.655 23.0244L15.9499 23.8654L9.95825 49.6279L16.4452 52.6648L19.4646 51.0062L20.1133 50.0835L19.158 41.3932C19.158 41.3932 14.7541 41.2619 14.931 37.1154Z",
    fill: "#C693AF",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5999 27.7738C11.5999 27.7738 9.05225 27.2598 9.05225 29.2805C9.05225 31.2545 11.1988 30.9041 11.1988 30.9041L11.5999 27.7738Z",
    fill: "#C693AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1047 31.6868L12.7063 27.0146",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1864 31.5505C11.1864 31.5505 12.5331 32.6177 11.8158 34.2417C11.0986 35.8658 9.88751 35.6885 9.12148 35.3502C8.35546 35.0119 7.74174 33.9492 8.32216 32.6349C8.89786 31.3314 9.86362 31.3459 9.86362 31.3459",
    stroke: "white",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3346 42.9816L19.1577 41.3931C19.1577 41.3931 14.754 41.2618 14.9309 37.1152C14.9427 37.1152 14.1214 42.0706 19.3346 42.9816Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.521 44.2904C46.521 42.4332 49.4578 41.6039 52.6659 41.6039C54.7535 41.6039 57.3483 40.4709 57.3483 44.2904C57.3483 47.2689 55.3433 47.6426 52.0054 47.6426C48.3727 47.6426 46.521 46.1359 46.521 44.2904Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8797 47.1403V27.7157L46.226 23.3706C46.226 23.3706 45.1527 21.2331 46.8747 20.3804C48.5967 19.5277 53.0786 17.9743 54.8595 21.9106C56.6405 25.8469 56.3574 45.3999 56.3574 45.3999L51.1443 50.2823L48.8797 47.1403Z",
    fill: "#C693AF",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7885 19.4341C48.8803 19.5276 48.7388 19.9481 48.7388 20.4737C48.7388 21.4548 50.1895 21.5366 50.3664 22.9266L52.6781 22.6346C52.3479 21.5249 50.3074 21.046 50.2721 20.2167C50.2603 19.8546 50.4608 19.3407 51.3807 19.3641",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.231 19.8315C47.2992 20.0768 47.0869 20.544 47.0869 21.0697C47.0869 22.0508 48.5376 22.1326 48.7145 23.5226",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3887 32.1074L28.1687 30.6473C28.1687 30.6473 26.9303 30.4254 26.7534 28.65C26.5765 26.8862 27.8974 26.6176 27.8974 26.6176L44.8225 24.6553L45.3887 32.1074Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9332 34.1862L38.8784 32.586C38.8784 32.586 36.201 31.9786 36.0949 28.6731C35.9887 25.2624 38.3004 24.4681 38.3004 24.4681L55.025 22.3423L55.9332 34.1862Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7812 27.4466C51.7812 30.0747 52.9961 34.1862 55.9329 34.1862C58.8697 34.1862 58.9405 30.5069 58.9405 27.9839C58.9405 25.461 57.1242 22.3423 55.0247 22.3423C52.9253 22.3423 51.7812 25.8931 51.7812 27.4466Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.355 26.0449C54.7181 26.0449 54.5176 26.9326 54.6356 28.2642C54.7417 29.5374 55.1191 30.098 55.7678 30.098C56.4165 30.098 56.4283 28.9183 56.334 27.9722C56.2278 27.0144 56.0863 26.0449 55.355 26.0449Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3239 32.9013L20.0778 31.3478C20.0778 31.3478 18.7568 31.1025 18.5799 29.2336C18.403 27.3648 19.7829 27.0728 19.7829 27.0728L37.7105 24.9937L38.3239 32.9013Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4933 35.0975L31.4242 33.4038C31.4242 33.4038 28.5935 32.7614 28.4756 29.2573C28.3576 25.648 30.8109 24.807 30.8109 24.807L48.5262 22.541L49.4933 35.0975Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0938 27.9607C45.0938 30.7407 46.3793 35.0975 49.4931 35.0975C52.6068 35.0975 52.6776 31.1962 52.6776 28.5214C52.6776 25.8466 50.7551 22.541 48.5259 22.541C46.2968 22.541 45.0938 26.3021 45.0938 27.9607Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8801 26.4775C48.2078 26.4775 47.9955 27.4237 48.1134 28.8253C48.2314 30.1802 48.6206 30.7643 49.3164 30.7643C50.0123 30.7643 50.0123 29.5145 49.9062 28.5099C49.8 27.5054 49.6467 26.4775 48.8801 26.4775Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0172 43.1221L34.9742 43.3557L33.665 43.9163V47.9461L43.4073 49.336L38.0172 43.1221Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4072 50.282C43.4072 50.282 43.4072 44.5353 43.4072 42.9467C43.4072 40.0967 44.1856 35.4362 43.1241 34.6186C41.2606 33.1936 40.9304 31.8503 40.9304 29.3273C40.9304 25.4027 42.4754 23.7441 44.0323 23.125C44.8343 22.8097 44.6456 21.3379 43.077 21.6767C41.5083 22.0154 38.371 24.3865 38.371 29.4792C38.371 29.4792 38.1469 23.4054 43.077 21.6767C43.077 21.6767 41.9919 20.5787 40.7416 21.4664C39.4914 22.3541 35.8705 23.9894 35.8705 29.4675C35.8705 29.4675 35.2454 24.4099 40.7416 21.4664C40.7416 21.4664 40.0458 20.6488 38.5243 21.4664C37.0028 22.284 33.488 24.772 33.488 30.437C33.488 36.102 35.21 35.8217 35.21 37.9942C35.21 40.1668 35.21 49.5812 35.21 49.5812L43.4072 50.282Z",
    fill: "#C693AF",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58716 102.307L27.8147 101.851L26.0573 62.0325L24.7953 50.1068L19.8298 47.3736C19.8298 47.3736 20.1365 50.5039 17.1407 50.5039C14.3572 50.5039 12.1162 49.6045 10.6183 46.9414L7.59895 51.9523V102.307H7.58716Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3475 46.9062C8.05942 46.9062 -2.79151 50.7725 -3.72328 59.2057C-4.67863 67.8259 -8.21698 99.4915 -8.86567 103.031C-9.51437 106.57 -9.07797 107.855 -6.48319 108.602C-3.8884 109.35 6.821 111.919 8.55479 112.352C10.2886 112.784 13.9685 112.352 14.0746 108.392C14.1808 104.432 13.6618 59.2174 13.6382 56.3207C13.6028 51.6485 12.0224 46.9062 10.3475 46.9062Z",
    fill: "#AE90E8",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.185 106.803C25.244 107.924 24.7486 109.151 27.025 108.567C29.2895 107.983 35.8826 105.25 36.6847 104.876C37.4867 104.502 37.2744 104.128 37.2272 103.159C37.1682 102.201 29.49 62.4409 29.49 62.4409L32.4504 77.8474C32.4504 77.8474 43.6552 84.5403 46.7925 86.4675C49.9299 88.3948 59.0116 89.2241 58.646 82.1575C58.2804 75.0908 57.3486 44.2896 57.3486 44.2896C57.3486 44.2896 54.9307 45.808 51.6047 45.808C48.2786 45.808 46.5213 44.2896 46.5213 44.2896L47.5946 71.4348C47.5946 71.4348 29.2306 52.1738 27.3198 50.1531C25.4091 48.1324 21.0216 46.4037 19.7124 46.4037C23.522 51.0291 25.185 106.803 25.185 106.803Z",
    fill: "#AE90E8",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65967 69.9167C3.65967 69.9167 30.2209 91.3035 32.9336 92.9388C35.6463 94.574 43.4897 96.1042 43.3953 88.8156C43.3009 81.527 43.3953 46.9413 43.3953 46.9413C43.3953 46.9413 41.3784 48.0626 37.3919 47.5604C34.2546 47.1632 31.7188 43.4138 35.2099 43.4138C35.2099 43.4138 32.9336 42.9816 32.9336 46.4974C32.9336 51.6251 32.9336 82.2629 32.9336 82.2629V79.4129L10.2292 55.9002",
    fill: "#AE90E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65967 69.9167C3.65967 69.9167 30.2209 91.3035 32.9336 92.9388C35.6463 94.574 43.4897 96.1042 43.3953 88.8156C43.3009 81.527 43.3953 46.9413 43.3953 46.9413C43.3953 46.9413 41.3784 48.0626 37.3919 47.5604C34.2546 47.1632 31.7188 43.4138 35.2099 43.4138C35.2099 43.4138 32.9336 42.9816 32.9336 46.4974C32.9336 51.6251 32.9336 82.2629 32.9336 82.2629V79.4129L10.2292 55.9002",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8248 15.2346C45.8244 15.2344 45.824 15.2342 45.8236 15.234C45.8331 15.2378 45.8339 15.239 45.8248 15.2346ZM46.2975 13.7097C46.0945 13.1295 45.7624 12.6541 45.3652 12.3514C45.0199 12.0883 44.3644 11.7918 43.7595 12.1941C43.5358 12.3429 43.3644 12.5538 43.2732 12.8204C43.19 13.0639 43.1912 13.3031 43.2115 13.4958C43.2489 13.8518 43.384 14.2895 43.5222 14.7375L43.5283 14.7571C43.7362 15.4399 44.1828 15.9636 44.5564 16.2861C44.7443 16.4483 44.9447 16.5866 45.1306 16.6761C45.2107 16.7147 45.3537 16.777 45.5231 16.7947C45.6032 16.8031 45.781 16.8124 45.9766 16.7231C46.2234 16.6104 46.403 16.383 46.4498 16.1073C46.4508 16.1013 46.4521 16.0939 46.4536 16.0854C46.4926 15.8623 46.6785 14.7988 46.2975 13.7097Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0228 11.2022C50.5204 11.2264 50.0496 11.4225 49.7414 11.8686C49.47 12.2614 49.4058 12.7379 49.4002 13.1513C49.3933 13.6563 49.5563 14.2839 49.7498 14.762C49.8487 15.0061 49.9756 15.262 50.1293 15.4702C50.2053 15.5731 50.3105 15.6956 50.449 15.7966C50.5844 15.8953 50.8209 16.0222 51.1276 15.9968L51.1276 15.9968L51.1294 15.9966C51.3729 15.9759 51.5582 15.8688 51.6713 15.7864C51.79 15.7 51.8867 15.5987 51.9618 15.5083C52.1123 15.3272 52.2416 15.1099 52.3446 14.9047C52.4497 14.6951 52.5421 14.4686 52.6097 14.2531C52.6727 14.0524 52.733 13.8033 52.733 13.5667C52.733 13.5506 52.7332 13.5321 52.7333 13.5113C52.7348 13.286 52.7381 12.7966 52.6036 12.3583C52.5265 12.1072 52.3845 11.7998 52.1075 11.5585C51.8106 11.2997 51.4335 11.1821 51.0228 11.2022ZM51.0228 11.2022C51.0231 11.2022 51.0233 11.2022 51.0235 11.2022L51.0617 12.0013L51.0222 11.2023C51.0224 11.2022 51.0226 11.2022 51.0228 11.2022Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6009 16.7932L56.601 16.7933L56.6131 16.7917C56.9544 16.7449 57.2204 16.5613 57.3923 16.4147C57.5758 16.2582 57.7363 16.0707 57.8682 15.8968C58.132 15.5491 58.3511 15.1618 58.4734 14.9391C58.6725 14.5808 58.7783 14.071 58.7969 13.6477C58.8066 13.4261 58.7954 13.1726 58.7335 12.9323C58.6776 12.7151 58.5407 12.3575 58.1803 12.1445C57.7529 11.8918 57.3292 12.019 57.0885 12.1494C56.8557 12.2756 56.6655 12.4639 56.5262 12.623C56.2379 12.9524 55.9776 13.3798 55.7999 13.7106C55.5435 14.1877 55.4626 14.8284 55.4668 15.2964C55.4689 15.5371 55.4936 15.8062 55.5662 16.0402C55.6008 16.1513 55.6656 16.3203 55.7961 16.4728C55.9427 16.6442 56.221 16.8393 56.6009 16.7932Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0276 18.7347C64.226 23.0926 65.4642 28.0178 65.4642 33.2321C65.4642 51.0334 51.0334 65.4642 33.2321 65.4642C15.4308 65.4642 1 51.0334 1 33.2321C1 15.4308 15.4308 1 33.2321 1C40.1176 1 46.4989 3.15905 51.7358 6.83708",
    stroke: "#040222",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBinoclar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/binoclar.2f663a69d84297b290b3ab95b54a0d07.svg";